import { isInputField } from '../../shared/answers';
import { STANDARD_FORM_NAME } from '../../shared/builtin';
import type { Field, PdfDocumentDefinition } from '../../shared/types';

const count = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;

/** The event's own questions on Review and publish: only those families answer, not section headings or title and
 * description blocks, and set apart from the standard registration questions every event asks. */
export function questionSummary(fields: Field[]): string {
  const questions = fields.filter(isInputField).length, sections = fields.filter(f => f.type === 'section').length;
  if (!questions) return 'Standard registration questions only; no additional questions';
  return `${count(questions, 'additional question', 'additional questions')}${sections ? ` in ${count(sections, 'section', 'sections')}` : ''}`;
}

/** Every form a family signs: the Permission and Medical Release Form, which every event includes, then the event's own. */
export function formSummary(documents: Pick<PdfDocumentDefinition, 'title'>[]): string {
  const names = [STANDARD_FORM_NAME, ...documents.map(d => d.title.trim() || 'Untitled form')];
  return `${count(names.length, 'form', 'forms')}: ${names.join(', ')}`;
}
